import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Navigation } from "swiper/modules";
import { motion, easeOut } from "framer-motion";
import { useLanguage } from "../../context/LanguageContext";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";

const imageVariant = {
  hidden: { scale: 1.1, opacity: 0 },
  visible: { scale: 1, opacity: 1, transition: { duration: 1, ease: easeOut } },
};

const textVariant = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 1.2, ease: easeOut } },
};

// Banner images (9)
const HamdanBanner: React.FC<{ content?: any }> = ({ content }) => {
  const { t_api } = useLanguage();
  const title = t_api(content?.title || "Hamdan Trading Group", content?.title_ar);
  const subtitle = t_api(content?.subtitle || "A legacy of growth, diversification, and contribution to the Sultanate of Oman since 1975", content?.subtitle_ar);
  const bannersList = [];
  for (let i = 1; i <= 9; i++) {
    const img = content?.[`banner_${i}_image` || `banner${i}`];
    if (img) bannersList.push({ image: img });
  }

  const slides = bannersList.length > 0 ? bannersList : (content?.banners || [
    { image: "/banner/banner.jpg" },
    { image: "/banner/banner2.jpg" },
    { image: "/banner/banner3.jpg" },
    { image: "/banner/banner4.jpg" },
    { image: "/banner/banner5.jpg" },
    { image: "/banner/banner6.jpg" },
    { image: "/banner/banner7.jpg" },
    { image: "/banner/banner8.jpg" },
    { image: "/banner/banner9.jpg" },
  ]);

  return (
    <section className="relative w-full h-screen">
      <Swiper
        modules={[EffectFade, Autoplay, Navigation]}
        effect="fade"
        loop
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        navigation={{
          nextEl: ".slider-next",
          prevEl: ".slider-prev",
        }}
        className="w-full h-full"
      >
        {slides.map((slide: any, idx: number) => (
          <SwiperSlide key={idx}>
            <motion.div
              initial="hidden"
              animate="visible"
              variants={imageVariant}
              className="relative w-full h-screen bg-cover bg-center flex items-center justify-center"
              style={{ backgroundImage: `url(${slide.image || '/banner/banner.jpg'})` }}
            >
              <div className="absolute inset-0 bg-black/60"></div>

              <div className="z-10 w-full h-full flex flex-col items-center justify-center px-4 relative -translate-y-12 md:-translate-y-20">
                <motion.div className="text-center" variants={textVariant}>
                  <motion.h2 className="text-white text-4xl md:text-6xl font-bold mb-4" variants={textVariant}>
                    {title}
                  </motion.h2>
                  <motion.p className="text-white text-lg md:text-2xl text-white/90 max-w-3xl mx-auto" variants={textVariant} transition={{ delay: 0.2 }}>
                    {subtitle}
                  </motion.p>
                </motion.div>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}

        {/* Navigation arrows */}
        <div className="slider-prev absolute left-4 top-1/2 -translate-y-1/2 z-30 text-white text-4xl cursor-pointer hover:scale-110 transition duration-300">
          ‹
        </div>
        <div className="slider-next absolute right-4 top-1/2 -translate-y-1/2 z-30 text-white text-4xl cursor-pointer hover:scale-110 transition duration-300">
          ›
        </div>
      </Swiper>

      {/* Wave Bottom */}
      <div className="absolute bottom-0 w-full overflow-hidden leading-none z-10">
        <svg
          className="w-full h-[60px] md:h-[90px]"
          viewBox="0 0 1440 80"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#ffffff"
            d="M0,5 C360,75 1080,75 1440,5 L1440,80 L0,80 Z"
          />
        </svg>
      </div>
    </section>
  );
};

export default HamdanBanner;
